import { mergeAttributes } from '@tiptap/core';
import { Paragraph } from '@tiptap/extension-paragraph';

const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      // <p title="hello">...</p> - browser tooltip
      title: {
        default: null,
        parseHTML: (element) => element.getAttribute('title'),
        renderHTML: (attributes) => ({ title: attributes.title }),
      },
      // <p data-json="${JSON.stringify(any_data)}">...</p>
      'data-json': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-json'),
        renderHTML: (attributes) => ({ 'data-json': attributes['data-json'] }),
      },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});

export default CustomParagraph;
